import { Reveal } from "../Reveal";
import { ASSETS } from "../assets";

export default function Slide03BrandWorld() {
  return (
    <section className="slide bg-[var(--ais-espresso)]" data-testid="slide-03">
      <div className="absolute inset-0">
        <img
          src={ASSETS.sandalsSunset}
          alt="AIS — Sandalo in handcrafted leather, Mediterranean villa"
          className="w-full h-full object-cover kenburns"
          style={{ objectPosition: "60% 85%" }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[var(--ais-espresso)] from-0% via-[var(--ais-espresso)]/78 via-38% to-transparent to-80%" />
        <div className="absolute inset-0 bg-gradient-to-t from-[var(--ais-espresso)]/55 via-transparent to-[var(--ais-espresso)]/45" />
      </div>

      <div className="relative min-h-screen flex items-center px-6 md:px-16 lg:px-24">
        <div className="max-w-3xl">
          <Reveal>
            <span className="font-sans text-[0.7rem] uppercase tracking-luxe text-[var(--ais-gold)]">
              03 — Brand World
            </span>
          </Reveal>
          <Reveal delay={1}>
            <div className="h-px w-16 my-8 bg-[var(--ais-gold)]/70" />
          </Reveal>
          <Reveal delay={2}>
            <h2 className="font-serif text-4xl md:text-6xl lg:text-[5rem] text-[var(--ais-cream)] leading-[1.05] tracking-[-0.01em] font-light drop-shadow-[0_2px_24px_rgba(0,0,0,0.8)]">
              <em className="italic">Quiet</em> opulence.
              <br />
              Uncompromising craft.
            </h2>
          </Reveal>
          <Reveal delay={3}>
            <p className="mt-10 font-sans text-[var(--ais-cream)] text-base md:text-lg max-w-xl leading-[1.85] font-light drop-shadow-[0_1px_14px_rgba(0,0,0,0.9)]">
              A Mediterranean sensibility, distilled in Italy and dedicated to a
              defined audience — the United Arab Emirates, Saudi Arabia, Qatar,
              Kuwait, Bahrain and Oman. A brand created for those who recognise
              true luxury without needing it announced.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
